import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=1a18166a"
import script from "./ImportButton.vue?vue&type=script&lang=ts"
export * from "./ImportButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports